import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'searchinpage',
    templateUrl: './searchinpage.component.html',
    styleUrls: ['./searchinpage.component.scss']
})
export class SearchinpageComponent implements OnInit {

    public searchinpage: string = '';
    constructor() { }

    ngOnInit() {
    }

    onKeyUp() {
        // window.find(this.searchinpage);
    }

}
